import { gql } from '@apollo/client';

export const QUERY_FAQ = gql`
  query GetFaqs {
    faqs {
      data {
        id
        attributes {
          name
          desc
          medias {
            data {
              attributes {
                name
                url
              }
            }
          }
        }
      }
    }
  }
`;
